module.exports = __webpack_public_path__ + "static/media/img1-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/nutricheck_foliar/P/img1-1.png
// module id = 1798
// module chunks = 3